import { PropertyType } from '../../../common';
import { propertiesFormatter } from '../../../common/services/propertiesFormatter';
import { columnFormatter } from '../../../view/pages/PlayerList/PlayerList.const';

export const mapApiToEntity = (data: PropertyType): PropertyType => {
	const mappedData = data.data.map((session: PropertyType) => {
		const newSessionData = propertiesFormatter(session, columnFormatter);
		newSessionData.user_name = newSessionData.user_name || 'N/A';

		return newSessionData;
	});

	return {
		players: mappedData,
		pagesTotal: data.pagination.total,
	};
};

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	sid: data.token,
	page: data.page,
	per_page: data.perPage || 10,
});
